import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { LoginComponent } from '../login/login.component';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import * as crypto from 'crypto-js';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { APIConstants } from '../../../../_config/restapis';
import { APIHeaderService } from '../../_services/header/API-header';
import { formatDate } from '@angular/common';
import { MustMatch } from '../../../../_helpers/must-match-validator';
import { BadWordsApiService } from 'src/app/_root/Trai_module/_services/bad-words/bad-words-api.service';
//import { FileSelectDirective, FileUploader } from 'ng2-file-upload';
import * as CryptoJS from 'crypto-js';
import { MatDialog, MatTable } from '@angular/material';

import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';

const uri = "http://10.163.2.8:8082/fileupload";
export interface headerTypeValues {
	key: string
	value: string
}
export interface PeriodicElementfile {
	doctype: string;
	docname: string;
	download: any;
	doc: string
}
export interface headercategorylist {
	name: string;
	value: number;
}

const ELEMENT_DATA_FILE: PeriodicElementfile[] = [
	{ doctype: "", docname: '', download: '', doc: 'DOC' },
	{ doctype: "", docname: '', download: '', doc: 'DOC2' },

];
@Component({
	selector: 'app-header-modify',
	templateUrl: './header-modify.component.html',
	styleUrls: ['./header-modify.component.css']
})
export class HeaderModifyComponent implements OnInit {
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;
	@ViewChild(MatTable) table: MatTable<any>;
	verified:boolean=false;
	email: any;
	mobileno: any;
	headerID: any;
	EntityDetails: any;
	submitted: boolean=false;
	showMsg: boolean = false;
	HeaderDetails: any;
	mobileNumber: any;
	emailId: any;
	mobileEmailFlag: boolean;
	emailIdSession: any;
	mobileNumberSession: any;
	IndCategory: any;
	OrgName: any;
	mailStatus: boolean=false;
	mobileStatus: boolean=false;
	EntityId: any;
	disableMobile:boolean=false;
	disableMail:boolean=false;


	constructor(private fb: FormBuilder,
		private ls: APILoginService,
		private es: APIEntityService,
		private hs: APIHeaderService,
		private $modal: $ModalManagerService,
		private db: $DBManagerService,
		private _route: ActivatedRoute,
		private bw: BadWordsApiService,
		private router: Router) {



	}
	response: any;
	headerForm: FormGroup;



	get f() { return this.headerForm.controls; }


	headercategorylistitems: headercategorylist[] = [
		{ name: "0 Others", value: 0 },
		{ name: "1 Banking / Insurance / Financial products / credit cards", value: 1 },
		{ name: "2 Real Estate", value: 2 },
		{ name: "3 Education", value: 3 },
		{ name: "4 Health", value: 4 },
		{ name: "5 Consumer Goods and Automobiles", value: 5 },
		{ name: "6 Communication / Broadcasting / Entertainment / IT", value: 6 },
		{ name: "7 Tourism and Leisure", value: 7 },
		{ name: "8 Food and Beverages", value: 8 },
	]
	headerType1 = [
		{ name: 'Promotional', value: 'P' },
		{ name: 'Others', value: 'O' },
		{ name: 'Transactional', value: 'T' },
		{ name: 'Service Explicit', value: 'SE' },
		{ name: 'Service Implicit', value: 'SI' },

	]


	async ngOnInit() {

		this.headerForm = this.fb.group({
			header_name: [''],
			header_id: [''],
			nature_business: ['',],
			industry_category: ['',],
			header_mobile: ['', [Validators.required, Validators.pattern("[1-9][0-9]{9}"), Validators.minLength(10)]],
			entity_name: ['',],

			header_email: ['', [Validators.required, Validators.pattern(/^([A-Za-z0-9._]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,6})*$/)]],
			industry_type: [''],
			sector: ['',],

			headerType: ['',],
			emailotpno: ['', [Validators.pattern("^[0-9]+$"), Validators.minLength(4), Validators.maxLength(4)],],

			mobileotpno: ['', [Validators.pattern("^[0-9]+$"), Validators.minLength(4), Validators.maxLength(4)]],
			header_category: [''],
		});//end of headerForm
		this._route.params.subscribe((params) => {
			this.headerID = params['urn'];

			console.log("The Hid is", this.headerID)

		})
		this.IndCategory = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_TYPE); //INDUSTRYCATEGORY
		this.OrgName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
		this.EntityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID)
		this.getHeaderDetails();
		this.getEntityDetails();



	}//end of oninit
	getEntityDetails() {
		var Entityquery = {
			Entity_ID: this.EntityId
		}
		this.es.getOneEntityFromMongo(Entityquery)
			.subscribe(r => {
				this.EntityDetails = r;

				if (r.E_Org_Type == 'G')
					this.headerForm.controls['industry_type'].setValue('Government');
				else if (r.E_Org_Type == 'P')
					this.headerForm.controls['industry_type'].setValue('Private');
				else if (r.E_Org_Type == 'S')
					this.headerForm.controls['industry_type'].setValue('SEBI');
				else if (r.E_Org_Type == 'O')
					this.headerForm.controls['industry_type'].setValue('Others');
				else
					this.headerForm.controls['industry_type'].setValue('');


				this.headerForm.controls['industry_category'].setValue(r.Entity_Industry);
				this.headerForm.controls['sector'].setValue(r.Entity_Sector);
				this.headerForm.controls['entity_name'].setValue(r.E_Org_Name);
			})
	}

	getHeaderDetails() {

		var data = {
			urn: this.headerID,

		}

		this.hs.getOneHeaderFromMongo(data)
			.subscribe(r => {
				this.HeaderDetails = r;
				this.headerForm.controls['header_id'].setValue(r.urn);
				this.headerForm.controls['nature_business'].setValue(r.NatureOfBusiness);
				this.headerForm.controls['header_mobile'].setValue(r.mobileNumber);
				this.headerForm.controls['header_email'].setValue(r.Email);
				this.headerForm.controls['headerType'].setValue(r.htyp);
				this.headerForm.controls['header_category'].setValue(r.ctgr);
				this.headerForm.controls['header_name'].setValue(r.cli);




			})

	}
	generateOTP(val) {

		var mobileNum = this.headerForm.get("header_mobile").value;
		var emailI = this.headerForm.get("header_email").value;
		let data = {
			EntityId: this.EntityId,
			otpFor: val,
			mobileNum: mobileNum,
			emailI: emailI

		}

		this.hs.resendOTPForHeader(data)
			.subscribe((r) => {
				if (r.message == "OTP sent") {
					this.$modal.successModal({
						title: 'OTP Notification',
						msg: 'OTP has been resend successfully'
					});
				}
				else {
					this.$modal.errorModal({
						title: 'OTP Notification',
						msg: 'Error resending the OTP'
					});
				}

			})
	}
	verifyOTP(value) {
		var OTP
		if(value=="Mobile")
		 OTP=this.headerForm.get("mobileotpno").value
		else if(value=="Email")
		 OTP=this.headerForm.get("emailotpno").value
		 else 
		 OTP=""

	//	let errors = this.entitymodifyForm.get("template_content").value;    

	  if( (value=="Email" && this.headerForm.controls['emailotpno'].invalid) || (value=="Mobile" && this.headerForm.controls['mobileotpno'].invalid)  ){
		  this.submitted=true
		  return;
	  }



		//let hid = this.db.get(Constants.SESSSION_STORAGE, Constants.HEADER_ID);
		var EntityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
		let data = {
			"otpFor": value,
			"OTP": OTP,

			// "emailOtp": emailOtp,
			// "mobileOtp": mobileOtp,
			"EntityId": EntityId
		}

		this.hs.sendEMOtpForHeader(data)
			.subscribe(r => {
				//console.log(" r  -- ",r); 
				console.log(" r.data  -- ", r.data);

				if (r.message == "success") {
					console.log("r.data.MobileNumber length", r.data.MobileNumber.length);
					console.log("r.data.MobileNumber", r.data.MobileNumber);
					console.log("r.data.EmailId", r.data.EmailId);
					if (r.data.EmailId.length !== 0) {
						console.log(" hello ");
						this.emailId = r.data.EmailId;
					}
					if (r.data.MobileNumber.length !== 0) {
						console.log(" bye ");
						this.mobileNumber = r.data.MobileNumber;
					}

					console.log(" this.mobileNumber  -- ", this.mobileNumber);
					console.log(" this.emailId  -- ", this.emailId);

					this.$modal.successModal({
						title: 'Header OTP Verification',
						msg: 'OTP successfully Verified'
					});
					if (r.mobileStatus == true) {
						this.verified=true;

						this.mobileStatus = false;
					//	this.headerForm.controls['header_mobile'].disable();
					}
					else if (r.emailStatus == true) {
						this.verified=true;
						this.mailStatus = false;
					//	this.headerForm.controls['header_email'].disable();
						
						

					}
					else {
						console.log("last ---");
					}
				}
				else if (r.message == "Time exceed") {
					this.$modal.errorModal({
						title: 'Header OTP Verification',
						msg: 'OTP Time limit Exceeded'
					});
				}
				else {
					this.$modal.errorModal({
						title: 'Header OTP Verification',
						msg: 'Invalid OTP'
					});
				}
			})

	}
	submitUpdateReg() {
		this.submitted = true;
		var mobileNum = this.headerForm.get("header_mobile").value;
		var emailI = this.headerForm.get("header_email").value;
		var emailId = this.HeaderDetails.Email;
		var mobileNumber = this.HeaderDetails.mobileNumber;
		console.log("mobile  email", mobileNum, emailI);
		console.log("this.emailId ", this.HeaderDetails.Email);
		//	console.log("this.emailVerify ",this.emailVerify); 
		console.log("this.mobileNumber ", this.HeaderDetails.mobileNumber);
		console.log("this.mobileNum ", mobileNum);

		if (emailId == emailI && mobileNumber == mobileNum) {
			console.log(" in error no change");
			this.mobileEmailFlag = true;

			this.$modal.errorModal({
				title: 'Header Modification',
				msg: 'Please change Mobile and/or Email'
			});	
			}
		else if (this.headerForm.invalid) {
			this.mobileEmailFlag = false;

			return;
		}
		else {
			console.log(" change");
			this.mobileEmailFlag = false;
			 

			if (emailId == emailI) {
				//this.emailId = "";
				emailI = ""
				console.log("In 1st", emailId)

				console.log("In 1st", emailI)
			}

			else if (mobileNumber == mobileNum) {
				//this.mobileNumber = "";
				mobileNum = "";
				console.log("In 1st", mobileNumber)

				console.log("In 2nd", mobileNum)

			}
			else {

			}

			let data = {
				mobileNumber: mobileNum,
				emailId: emailI,
				entityType: this.IndCategory,
				OrgName: this.OrgName,
				EntityId: this.EntityId,

			}
			console.log("In ", data)

			this.hs.updateMobileEmailInMongoModify(data)
				.subscribe((r) => {
					console.log("result ", r);
					console.log("r.mailStatus ", r.mailStatus);
					console.log("r.mobileStatus ", r.mobileStatus);

					if ((r.mailStatus == true) && (r.mobileStatus == true)) {
						console.log("ikkk");
						if( emailId != emailI)
						this.mailStatus = true;
						if(mobileNumber != mobileNum)
						this.mobileStatus = true;
					}
					if (r.mailStatus == true && r.mobileStatus !== true && emailId != emailI) {

						this.mailStatus = true;
					}
				     if (r.mobileStatus == true && r.mailStatus !== true && mobileNumber != mobileNum) {
						console.log("sdfsdfsdf");
						this.mobileStatus = true;
					}
				    if ((r.mailStatus == true) && (r.mobileStatus == true) && emailId != emailI && mobileNumber != mobileNum) {
						console.log("ikkk");
						this.mailStatus = true;
						this.mobileStatus = true;
					}
					else {
						console.log("ehshdhg");
					}
					if (r.message == "Header Email/Mobile updated successfully") {
						this.$modal.successModal({
							title: 'Email/Mobile Updation',
							msg: 'OTP has been send to the Email/Mobile. Please verify'
						});
					}
					else {
						this.$modal.errorModal({
							title: 'Email/Mobile Updation',
							msg: 'Error in Updating the Values'
						});
					}

				})
		}

	}
	onSubmit() {
		//this.submitted=true
		console.log("OnSubmit Called");
		console.log("this.mail",this.mailStatus);
		console.log("this.mobileStatus",this.mobileStatus);
		console.log("mobileemailflag",this.mobileEmailFlag);
		console.log("!mobileemailflag",!this.mobileEmailFlag);

		console.log("submitted",this.submitted);

	    if ((!this.submitted && !this.mobileStatus && !this.mailStatus)||(this.submitted && !this.verified )) {
			this.$modal.errorModal({
				title: 'Header Modification',
				msg: 'Please validate Mobile and/or Email'
			});

		 }
	   else if (this.mobileEmailFlag == true) {
		this.$modal.errorModal({
			title: 'Header Modification',
			msg: 'Please change Mobile and/or Email'
		});
		}
		// else if (this.headerForm.invalid) {
		// 	return;
		// }
		else {

			var entityForm = {
				urn: this.headerID
			}

		
			if(this.mailStatus == false){
			entityForm["header_email"] = this.headerForm.get("header_email").value;
			}
		 if(this.mobileStatus == false){
			entityForm["header_mobile"] = this.headerForm.get("header_mobile").value;
   }
			
			console.log("FORM VALUESSSSS", this.headerForm.value)

			console.log("entityForm", entityForm)

			this.hs.modifyHeader(entityForm)
				.subscribe(r => {
					console.log("response -- ", r);
					console.log("status ", r.status);
					if (r.status == "success") {
						// this.emailotpno=true;
						this.$modal.successModal({
							title: 'Header Modification',
							msg: 'Header Details have been updated successfully. Your new URN is '+ r.URN
						});
						//this.showMsg= true;
					}
					else {
						// this.emailotpno=true;
						this.$modal.errorModal({
							title: 'Header Modification',
							msg: 'Some Error Ocurred'
						});
						//this.showMsg= true;
					}


				})
				this.router.navigateByUrl('/headers-by-pe');

		}
	}


}//end of export
